export const CAROUSEL_GAP = {
    desktop: 8, // px
    tablet: 8, // px
    mobile: 4 // px
};

export const CAROUSEL_BORDER_RADIUS = 8; // px

export const CAROUSEL_IMAGE_LAYOUT = 'layout1x1';
